import React, { createContext, useContext } from "react";
import { Steps, Button, message, Drawer, notification } from "antd";
import { UploadDateSelect } from "./UploadDateSelect";
import { ConsumptionEntry } from "./ConsumptionEntry";
import { ReviewConsumption } from "./ReviewConsumption";
import { observer } from "mobx-react-lite";
import WizardStore from "../store/wizardstore";
import { toJS } from "mobx";
import { getCurrentUser } from "../../../Utility/modules/helpers";
import materialStore from "../store/materialstore";
const wizardStoreCtx = createContext(WizardStore);
const { Step } = Steps;

export const UploadWizardBaseView = observer(() => {
  const wizardStore = useContext(wizardStoreCtx);

  const steps = [
    {
      title: "Select Date",
      content: <UploadDateSelect />,
    },
    {
      title: "Consumption Data",
      content: <ConsumptionEntry />,
    },
    {
      title: "Review & Save",
      content: <ReviewConsumption />,
    },
  ];
  const next = () => {
    wizardStore.current += 1;
  };

  const prev = () => {
    wizardStore.current -= 1;
  };

  const saveConsuptions = async () => {
    try {
      let consumptions = [...wizardStore.importConsumptions.values()].map(
        (c) => {
          return {
            ...toJS(c),
            assetId: wizardStore.materialStore.mainStore.assetContextId,
            productionDate: wizardStore.productionDate,
            uploadedBy: getCurrentUser()?.fullName,
            uploadedOn: new Date(),
          };
        }
      );
      const retVal = await materialStore.saveConsumptions(consumptions);
      console.log("retVal", retVal);
      await materialStore.loadchemicals();
      await materialStore.loadConsumptions();
      message.success("Material consumptions saved successfully");
      materialStore.showWizardDialog = false;
    } catch (error) {
      notification.error({
        message: "SPARS Feedback",
        description: error.response.text,
      });
    } finally {
      materialStore.isSaving = false;
    }
  };

  return (
    <Drawer
      title=" Add Material Consumption"
      placement="right"
      closable={true}
      onClose={() => {
        wizardStore.materialStore.showWizardDialog = false;
      }}
      visible={wizardStore.materialStore.showWizardDialog}
      width="50%"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent:
              wizardStore.current === 0 ? "flex-end" : "space-between",
          }}
        >
          {wizardStore.current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {wizardStore.current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {wizardStore.current === steps.length - 1 && (
            <Button
              type="primary"
              onClick={saveConsuptions}
              disabled={wizardStore.importConsumptions.size === 0}
              loading={materialStore.isSaving}
            >
              Save
            </Button>
          )}
        </div>
      }
    >
      <Steps current={wizardStore.current}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div style={{ padding: "10px" }}>
        {steps[wizardStore.current].content}
      </div>
    </Drawer>
  );
});

